export const nodeType = 'application-architecture-node'
export const appArchitecturePortOut = 'app-architecture-out'
